<template>
  <div class="container">
    <!-- {{ list }} -->

<!--
  <div class="list">
    <h1>Historque inventaire</h1>
    <table border="1">
      <thead>
        <tr>
          <th>Date</th>
          <th>Quantité saisie</th>
          <th>Quantité theorique</th>
          <th>Ecart</th>
        </tr>
      </thead>
        <tbody>
          <Inventory
          :key="index"
          :inventory="inventory"
          @onInput="saveQuantity"
          v-for="(inventory,index) in list" />
      </tbody>
    </table>
  </div> -->

  <el-table
     v-if="list.length"
     :data="list"
     border
     style="width: 100%,">
     <el-table-column
       prop="nameDisplayed"
       label="Nom"
       width="350">
     </el-table-column>
     <el-table-column
     prop="unit"
     label="Unité"
     width="150">
   </el-table-column>
     <el-table-column
       prop="family"
       label="Famille"
       width="120">
     </el-table-column>
     <el-table-column
       prop="quantityAreaSelling"
       label="Zone avant"
       width="100">
     </el-table-column>
     <el-table-column
       prop="quantityAreaStock"
       label="Zone arrière"
       width="100">
     </el-table-column>
     <el-table-column
       prop="displayTotal"
       label="Total"
       width="100">
     </el-table-column>
   </el-table>

   <div v-if="list.length === 0">
     Aucun historique trouvé.
   </div>

   <div v-if="displayButtonImport">
     <el-alert
        title="Cliquez sur le bouton ci-dessous pour synchroniser l'historique
        de cet inventaire saisi sur l'intranet"
        type="info"
        show-icon>
     </el-alert>
     <el-button type="primary"  icon="el-icon-upload2" class="button-action"
      @click="importInventaireHistory">
       Récupérer l'historique
     </el-button>
  </div>
 </div>
</template>

<script>
// import Inventory from '@/components/Inventory/Inventory.vue';
// import Card from '@/components/Card/Card.vue';
// import services from 'services';
// import _ from 'lodash';

export default {
  components: {
    // Inventory,
    // Card,
  },
  props: {
    list: Array,
    inventoryId: undefined,
  },
  data() {
    return {
      errors: [],
      unit: '',
      displayingMessageImport: 1,
      // listingProducts: [],
    };
  },
  computed: {
    displayButtonImport() {
      return this.list.length === 0
        && this.inventoryId !== undefined
        && this.inventoryId !== ''
        && parseInt(this.inventoryId, 10) < 63;
    },
  },
  methods: {
    displaySuccessMessage(message) {
      this.$message({
        showClose: true,
        message,
        type: 'success',
      });
    },
    displayErrorMessage(message) {
      this.$message({
        showClose: true,
        message,
        type: 'error',
      });
    },
    async importInventaireHistory() {
      if (this.displayButtonImport) {
        this.$emit('onImportInventaireHistory');
      } else {
        this.displayErrorMessage("Impossible d'importer l'historique de cet inventaire");
      }
    },
  },
  mounted() {
    this.displayingMessageImport = 1;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

.text-danger
  color: red;

.container
  margin: 10px 20px;

.el-table
  width: fit-content;

$margin = 25px;

.el-alert {
    margin: $margin;
    width: 80%;
}

.el-button {
    margin: 0px $margin;
}

</style>
